import React from 'react';
import { useSelector } from 'react-redux';
import { StringHelpers, Modal } from '@salesperformanceint/e4shared';
import Bullet from 'components/prism/bullet';
import { Overtime } from '../overtime';
import { apiGet } from 'services';

export const Metric = ({ metric, loading, period }) => {
    const user = useSelector(state => state.user.user);
    const loaded = React.useRef(null);
    const [showDetails, setShowDetails] = React.useState(false);
    const [overtimeData, setOvertimeData] = React.useState([]);
    const [loadingOvertime, setLoadingOvertime] = React.useState(true);
    const infinite = metric.change === -2147483648;

    React.useEffect(() => {
        if (!showDetails || overtimeData?.length) {
            return;
        }

        setLoadingOvertime(true);
        if (user?.id) {
            const url =
                metric.type === 'CRM'
                    ? `crm-over-time/${user.id}/${metric.id}`
                    : `integration-overtime/${user.id}/${metric.id}`;
            apiGet(url, user.guid, response => {
                setOvertimeData(response);
                setLoadingOvertime(false);
            });
        }
    }, [metric, user, showDetails]);

    const icon = metric.type === 'CRM' ? '/dist/img/bespoke_crm-icon.png' : '/dist/img/e4-icon.png';

    return (
        <div ref={loaded} data-testid="metric-item" key={`metric-${metric.id}`} className="prism-metric metric-small">
            <div className="mb10">
                <img src={icon} alt="" className="metric-icon" />
                <span className="prism-metric-name">{metric.name}</span>
            </div>
            {loading ? (
                <i className="fa fa-spinner fa-spin" />
            ) : (
                <div>
                    <div className="prism-metric-score">
                        <div className="prism-metric-score-value" style={{ overflow: 'hidden' }}>
                            <span className="label-text-fit">
                                {StringHelpers.formatMetric(metric.format, metric.value, user.currencySymbol)}
                            </span>
                        </div>
                        <Bullet
                            icon={infinite || metric.change >= 0 ? 'arrow-up' : 'arrow-down'}
                            value={infinite ? ' ' : `${metric.change >= 0 ? metric.change : metric.change * -1}%`}
                            style={infinite || metric.change >= 0 ? 'positive round' : 'negative round'}
                        />
                    </div>
                    <button className="btn-link" onClick={() => setShowDetails(true)}>
                        View Details
                    </button>
                </div>
            )}
            <Modal show={showDetails} close={() => setShowDetails(false)} title={metric.name} footer={null}>
                <div>{metric.description}</div>
                <div style={{ height: '500px', width: '95%' }}>
                    <Overtime data={overtimeData} metric={metric} />
                </div>
            </Modal>
        </div>
    );
};

export default Metric;
